// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TestClockAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TestClockAdvanceResponse — result of
 * POST /subscriptions/admin/test-clock/{subscription_id}/advance  (S11 · C1).
 *
 * offset_days_total is the CUMULATIVE offset after this advance, not the days
 * of this call. The clock is permanent and additive by decision (Stripe-style,
 * no rollback), so the only number worth showing a human is the total distance
 * this subscription's dates now sit from real time.
 *
 * `shifted` reports what moved — see Subscriptions_TestClockShiftedRow.
 *
 * `chronology` (C2) reports what the advance CAUSED: one row per cycle boundary
 * crossed, in chronological order, carrying the webhook that was emitted for it
 * through the signed GatewayTest door and what the real ingest did with it. An
 * empty list means the advance crossed no boundary — the dates simply moved.
 * A failed emission appears here as a `failed:<motivo>` row and does NOT undo
 * the shift: the displacement is permanent and cumulative by decision, so a
 * partial chronology is the truth rather than a reason to lie about the dates.
 *
 * C3 APPENDS to the same list: after the webhook ('webhook'-kind) rows, one
 * 'job'-kind row per real billing job the advance fired (overdue_detection,
 * then subscription_sweep) — see Subscriptions_TestClockChronologyRow's `kind`
 * field and Test_clock::runBillingJobs(). The list is therefore never empty
 * for a successful advance since C3, even when zero boundaries were crossed.
 *
 * This envelope is only ever emitted for a SUCCESSFUL advance. Every refusal
 * (gate, unknown subscription, real gateway, bad days) leaves through
 * sendError(): sendResponse() hard-codes success=true at the envelope level, so
 * a refusal placed inside `dados` reads as success to every caller — the bug
 * class that has shipped three times in this console (skill
 * billing-staff-console §4).
 */
import type { Subscriptions_TestClockChronologyRow } from './Subscriptions_TestClockChronologyRow'
import type { Subscriptions_TestClockShiftedRow } from './Subscriptions_TestClockShiftedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_TestClockAdvanceResponseDados {
offset_days_total: number
shifted: Subscriptions_TestClockShiftedRow
chronology: Subscriptions_TestClockChronologyRow[]
}

export type Subscriptions_TestClockAdvanceResponse = ApiResponse<Subscriptions_TestClockAdvanceResponseDados>;

registerResponseContract('Subscriptions_TestClockAdvanceResponse', {
  offset_days_total: { type: 'number',  required: true },
  shifted: {
    type: 'object',
    required: false,
    fields: {
      subscription_period: { type: 'boolean', required: false },
      grace_windows:       { type: 'number',  required: false },
    },
  },
  chronology: {
    type: 'array',
    required: true,
    items: {
      kind:       { type: 'string',  required: false },
      boundary:   { type: 'string',  required: false },
      event_type: { type: 'string',  required: false },
      event_id:   { type: 'string',  required: false },
      outcome:    { type: 'string',  required: false },
      detail:     { type: 'string',  required: false },
      job_type:   { type: 'string',  required: false },
      run_id:     { type: 'number',  required: false },
      summary:    { type: 'string',  required: false },
    },
  },
})
